import React from "react";
import { Link } from "react-router-dom";
const About = () => (
  <div>
    <header className="main_menu">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-12">
            <nav className="navbar navbar-expand-lg navbar-light">
              <Link className="navbar-brand" to="/">
                {" "}
                <img src="img/logo.png" className="logo" alt="logo" />{" "}
              </Link>
              <button
                className="navbar-toggler"
                type="button"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon" />
              </button>
              <div
                className="collapse navbar-collapse main-menu-item justify-content-end"
                id="navbarSupportedContent"
              >
                <ul className="navbar-nav">
                  <li className="nav-item active">
                    <Link className="nav-link" to="/">
                      Home{" "}
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="/about">
                      About
                    </Link>
                  </li>

                  <li className="nav-item active">
                    <Link className="nav-link" to="/contact">
                      Contact
                    </Link>
                  </li>
                </ul>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </header>
    {/* Header part end*/}
    {/*::breadcrumb part start::*/}
    <section className="breadcrumb breadcrumb_bg">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="breadcrumb_iner">
              <div className="breadcrumb_iner_item">
                <h2>About Us</h2>
                <p>
                  Home <span>-</span>About Us
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    {/*::breadcrumb part start::*/}
    {/* about part start*/}
    <section className="about_part single_padding_top">
      <div className="container">
        <div className="row align-items-center justify-content-end">
          <div className="col-md-6 col-lg-6 col-xl-5">
            <div className="about_img">
              <img src="img/about_img_1.png" alt="" />
            </div>
          </div>
          <div className="col-md-6 col-lg-6 offset-xl-1 col-xl-6">
            <div className="about_text">
              {/* <h2>We Have 24 Year Expereince in consulting</h2>
              <h4>First Abundantly night you are sea great fifth year</h4> */}
              <p style={{ fontSize: 18 }}>
                Mansarovar Urban Cooperative Bank Ltd, was established in the
                year 1986 under U.P. Cooperative societies Act 1965 and was
                issued banking licence to carry on the business of banking in
                the same year. Since establishment the bank is catering to the
                financial needs of its customers particularly the lower income
                group and under previliged people of the society.
              </p>
              <h2 style={{ marginTop: 30, color: "#ff7e5f" }}>Vision</h2>
              <p style={{ fontSize: 18 }}>
                To extend financial support to all sections of the society
                particularly middle and lower-income groups by way of providing
                credit on affordable interest rates. And also to help people in
                generating self-employment and play a greater role in financial
                inclusion.
              </p>
              <h2 style={{ marginTop: 30, color: "#ff7e5f" }}>Road Ahead</h2>
              <p style={{ fontSize: 18 }}>
                To keep pace with changing financial scenarios and technology
                adoption in banking, we aim to provide the best of services to
                our customers. We are already providing digital services to our
                customers by way of RTGS / NEFT services, SMS alerts, and ATM
                cum debit card facility, POS and RCOM payment facility. In the
                near future, we plan to provide micro ATM, mobile banking and
                other technology driven services to our customers.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="hero-app-7 custom-animation">
        <img src="img/animate_icon/icon_1.png" alt="" />
      </div>
      <div className="hero-app-8 custom-animation2">
        <img src="img/animate_icon/icon_2.png" alt="" />
      </div>
      <div className="hero-app-6 custom-animation3">
        <img src="img/animate_icon/icon_3.png" alt="" />
      </div>
    </section>
    {/* about part start*/}
    {/*::review_part start::*/}
    {/*::blog_part end::*/}
    {/* our_service_part part start*/}
    <footer className="copyright_part">
      <div className="container">
        <div className="row align-items-center">
          <p className="footer-text m-0 col-lg-8 col-md-12">
            {/* Link back to Colorlib can't be removed. Template is licensed under CC BY 3.0. */}
            Copyright MUCB © All rights reserved 2020 | Made with{" "}
            <i className="ti-heart" aria-hidden="true" /> by{" "}
            <a href="https://colorlib.com" target="_blank">
              Colorlib
            </a>{" "}
            in{" "}
            <a
              style={{ color: "#61dafb" }}
              href="https://reactjs.org"
              target="_blank"
            >
              React
            </a>
            {/* Link back to Colorlib can't be removed. Template is licensed under CC BY 3.0. */}
          </p>
        </div>
      </div>
    </footer>
  </div>
);

export default About;
